import { render, staticRenderFns } from "./AgreementTable.vue?vue&type=template&id=58f99be0&scoped=true"
import script from "./AgreementTable.vue?vue&type=script&lang=js"
export * from "./AgreementTable.vue?vue&type=script&lang=js"
import style0 from "./AgreementTable.vue?vue&type=style&index=0&id=58f99be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f99be0",
  null
  
)

export default component.exports